import Link from 'next/link'
import { useSnapshot } from 'valtio'
import cn from 'classnames'

import { type ReactElement, useEffect } from 'react'
import { PlaceholderBox } from '../../../../../shared/components/ui/PlaceholderBox'
import { ErrorBox } from '../../../../../shared/components/ui/ErrorBox'
import { APP_TRANSACTIONS_PATH } from '../../../../../pages/app/transactions'
import { proxyGlobalAuth } from '../../../../../shared/proxies/proxyGlobalAuth'
import {
  throttledFetchRecentActivities,
  recentActivitiesProxy
} from './recentActivitiesProxy'
import { Heading } from './Components/Heading'
import { RecentActivityRows } from './Components/RecentActivityRows'

export function RecentActivitySubSection (): ReactElement {
  useEffect(() => { void throttledFetchRecentActivities() }, [])
  const { apiCall } = useSnapshot(recentActivitiesProxy)

  const { siteTheme: { tableHeaderColors } } = useSnapshot(proxyGlobalAuth)

  return (
    <div className="w-1/2">
      <div className="w-full bg-white shadow-lg mx-4 px-4 py-2">
        <Heading />
        <hr className="my-1" />
        <PlaceholderBox loading={apiCall.loading} rows={12}>
          <ErrorBox error={apiCall.error}>
            <table className="w-full my-3 ">
              <thead className={cn(tableHeaderColors.backgroundClasses, tableHeaderColors.secondaryFontClasses, 'text-left')}>
                <tr>
                  <th className="p-2">Date</th>
                  <th className="p-2">Company</th>
                  <th className="p-2">Name</th>
                  <th className="p-2 text-right">Amount</th>
                </tr>
              </thead>
              <tbody>
                <RecentActivityRows />
              </tbody>
            </table>
          </ErrorBox>
        </PlaceholderBox>
        <hr className="my-1" />
        <div className="text-center">
          <Link href={APP_TRANSACTIONS_PATH}>
            <div className="opacity-95 underline text-sm hover:text-blue-700 active:text-blue-600">
              View All Activity
            </div>
          </Link>
        </div>
      </div>
    </div>
  )
}
